import React from 'react'

import OPFullLogo from '../Images/OPFullLogo'
import { DashboardItemProps } from '../types'
import { ProgramLogoContainer } from './ProgramLogo.styled'

function ProgramLogo({ componentStyle }: DashboardItemProps) {
    return (
        <ProgramLogoContainer componentStyle={componentStyle}>
            <OPFullLogo />
        </ProgramLogoContainer>
    )
}

export default ProgramLogo
